export default "__VITE_ASSET__CIi$_Zeu__"